import { render, staticRenderFns } from "./MyAccreditation.vue?vue&type=template&id=5f5084c5&scoped=true&"
import script from "./MyAccreditation.vue?vue&type=script&lang=js&"
export * from "./MyAccreditation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5084c5",
  null
  
)

export default component.exports